import countdown from "./background.jpg";

const obj = {
  countdown,
};

export default obj;
